import React from 'react';
import { Bell, Car, FileText, Home, UserRound } from 'lucide-react';
import { useOwnerService } from '../../contexts/OwnerServiceContext';
import { toBn } from '../../utils/bn';
import type { OwnerNav, OwnerScreen } from '../../types/owner';
const items: {
  key: OwnerScreen;
  label: string;
  icon: typeof Home;
  match: OwnerScreen[];
}[] = [{
  key: 'home',
  label: 'হোম',
  icon: Home,
  match: ['home']
}, {
  key: 'vehicles',
  label: 'আমার গাড়ি',
  icon: Car,
  match: ['vehicles', 'vehicleDetail', 'drivers', 'docTracker', 'qr']
}, {
  key: 'tracking',
  label: 'আবেদন',
  icon: FileText,
  match: ['tracking']
}, {
  key: 'notifications',
  label: 'নোটিফিকেশন',
  icon: Bell,
  match: ['notifications']
}, {
  key: 'account',
  label: 'প্রোফাইল',
  icon: UserRound,
  match: ['account']
}];
export function OwnerBottomNav({
  nav
}: {
  nav: OwnerNav;
}) {
  const {
    notifications
  } = useOwnerService();
  const unread = notifications.filter(n => !n.read).length;
  return <nav className="grid shrink-0 grid-cols-5 border-t border-border bg-white px-1 pb-3 pt-1.5" aria-label="প্রধান মেনু" data-id="element-1268" data-mp="2041n2dnxriro">
      {items.map(({
      key,
      label,
      icon: Icon,
      match
    }) => {
      const on = match.includes(nav.screen);
      return <button key={key} onClick={() => nav.reset(key)} aria-current={on ? 'page' : undefined} className={`relative flex flex-col items-center gap-0.5 text-[10.5px] font-medium ${on ? 'text-navy-800' : 'text-slate-400'}`} data-id="element-1269" data-mp="10yldpspxbc5j">
            <span className={`flex h-7 w-10 items-center justify-center rounded-full ${on ? 'bg-navy-50' : ''}`} data-id="element-1270" data-mp="maqgq04vulmn">
              <Icon className="h-[18px] w-[18px]" data-id="element-1271" data-mp="i83ovz87p0pg" />
            </span>
            {label}
            {key === 'notifications' && unread > 0 && <span className="absolute right-3 top-0 flex h-4 min-w-4 items-center justify-center rounded-full bg-flagred px-1 text-[9px] font-bold text-white" data-id="element-1272" data-mp="d7peiaj51eo9">{toBn(unread)}</span>}
          </button>;
    })}
    </nav>;
}